import React from "react";
import styles from "./style.module.scss";
import image404 from "./404.svg";
import Button from "~/components/common/atoms/Button";
import { MDBContainer } from "mdbreact";
export const Page404 = () => {
  return (
    <MDBContainer className={styles.notFoundContainer}>
      <div className={styles.notFoundWrapper}>
        <img src={image404} alt="" width={500} height={500} />
        <div className={styles.content}>
          Trang bạn tìm kiếm không đúng hoặc không tồn tại !.
          <a href="/">
            <Button className={styles.btnHome}>Trở về trang chủ</Button>
          </a>
        </div>
      </div>
    </MDBContainer>
  );
};
